import { Button } from '@rneui/themed'
import { Image } from 'expo-image'
import { getIcons } from 'home/stack/icons'
import { Route } from 'home/stack/types'
import React from 'react'
import { StyleSheet } from 'react-native'
import { Badge } from 'shared/components/user/badge_counter'

type Props = {
  route: Route
  onPress(): void
  darkMode: boolean
  badgeCountValue?: number | string
  disabled?: boolean
}

export function RouteButton({
  route,
  onPress,
  darkMode,
  badgeCountValue,
  disabled,
}: Props) {
  const icons = getIcons(darkMode, disabled)
  const image = icons[route.name]

  return (
    <>
      <Button
        disabled={disabled}
        type="clear"
        buttonStyle={styles.button}
        containerStyle={{ overflow: 'visible' }}
        icon={
          image ? (
            <>
              {!disabled ? (
                <Badge
                  value={badgeCountValue}
                  position={'absolute'}
                  xOffset={25}
                  yOffset={30}
                />
              ) : null}

              <Image style={styles.icon} source={image} contentFit="contain" />
            </>
          ) : undefined
        }
        onPress={onPress}
      />
    </>
  )
}

export const styles = StyleSheet.create({
  button: {
    width: 44,
    height: 44,
    borderRadius: 10,
  },
  icon: {
    width: 32,
    height: 32,
  },
})
